import styled from 'styled-components';

export const Wrapper = styled.div``;
export const WarnBoxSpan = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
  margin-inline-start: ${({ theme }) => theme.spacing.x3};
  color: ${({ theme }) => theme.palette.gray80};
  font-weight: 500;
  line-height: ${({ theme }) => theme.spacing.x3};
`;
export const WarnBoxSvg = styled.div`
  color: ${({ theme }) => theme.palette.gray80};
`;
